"use strict";

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbnailEmitter = exports.PlayerEmitter = void 0;

var PlayerEmitter = /*#__PURE__*/function () {
  function PlayerEmitter() {
    _classCallCheck(this, PlayerEmitter);

    this.listeners = {
      ended: [],
      error: [],
      pause: [],
      play: [],
      ratechange: [],
      seeked: [],
      timeupdate: [],
      frameupdate: [],
      fullscreenchange: []
    };
  }

  _createClass(PlayerEmitter, [{
    key: "addEventListener",
    value: function addEventListener(name, callback) {
      this.listeners[name].push(callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(name, callback) {
      this.listeners[name] = this.listeners[name].filter(function (l) {
        return l !== callback;
      });
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(dispatchName, context) {
      this.listeners[dispatchName].forEach(function (callback) {
        callback({
          detail: context
        });
      });
    }
  }, {
    key: "dispatchSeek",
    value: function dispatchSeek(frame) {
      this.dispatchEvent('seeked', {
        frame: frame
      });
    }
  }, {
    key: "dispatchPause",
    value: function dispatchPause() {
      this.dispatchEvent('pause', undefined);
    }
  }, {
    key: "dispatchPlay",
    value: function dispatchPlay() {
      this.dispatchEvent('play', undefined);
    }
  }, {
    key: "dispatchEnded",
    value: function dispatchEnded() {
      this.dispatchEvent('ended', undefined);
    }
  }, {
    key: "dispatchRatechange",
    value: function dispatchRatechange(playbackRate) {
      this.dispatchEvent('ratechange', {
        playbackRate: playbackRate
      });
    }
  }, {
    key: "dispatchError",
    value: function dispatchError(error) {
      this.dispatchEvent('error', {
        error: error
      });
    }
  }, {
    key: "dispatchTimeUpdate",
    value: function dispatchTimeUpdate(event) {
      this.dispatchEvent('timeupdate', event);
    }
  }, {
    key: "dispatchFrameUpdate",
    value: function dispatchFrameUpdate(event) {
      this.dispatchEvent('frameupdate', event);
    }
  }, {
    key: "dispatchFullscreenChangeUpdate",
    value: function dispatchFullscreenChangeUpdate(event) {
      this.dispatchEvent('fullscreenchange', event);
    }
  }]);

  return PlayerEmitter;
}();

exports.PlayerEmitter = PlayerEmitter;

var ThumbnailEmitter = /*#__PURE__*/function () {
  function ThumbnailEmitter() {
    _classCallCheck(this, ThumbnailEmitter);

    this.listeners = {
      error: []
    };
  }

  _createClass(ThumbnailEmitter, [{
    key: "addEventListener",
    value: function addEventListener(name, callback) {
      this.listeners[name].push(callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(name, callback) {
      this.listeners[name] = this.listeners[name].filter(function (l) {
        return l !== callback;
      });
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(dispatchName, context) {
      this.listeners[dispatchName].forEach(function (callback) {
        callback({
          detail: context
        });
      });
    }
  }, {
    key: "dispatchError",
    value: function dispatchError(error) {
      this.dispatchEvent('error', {
        error: error
      });
    }
  }]);

  return ThumbnailEmitter;
}();

exports.ThumbnailEmitter = ThumbnailEmitter;